import {
  FtBtnBox,
  InspectResultBox,
  InspectResultContainer,
  NoiseResultBox,
  SensitivityResulBox,
  SensitivityResultSubBox,
} from "style/inspect";
import InspectResultHeader from "./inspect.result.header";
import InspectShareBox from "components/inspect/items/inspect.share.box";
import { getResultsFromType } from "utils/inspect.util";
import { useParams } from "react-router-dom";

const InspectResultDetail = () => {
  const { id } = useParams<{ id: string }>();

  const { sensitivityResult, noiseResult } = getResultsFromType(Number(id))!;

  return (
    <InspectResultContainer>
      <InspectResultHeader backPath="/inspect" />
      {/* <InspectResultBox>
        <SensitivityResulBox>
          <div className="title">
            <span>나와 닮은 동물은</span>
            <h3>{sensitivityResult?.title}</h3>
          </div>
          <div className="img-box">
            <img src={sensitivityResult?.imgPath} alt="" />
          </div>
          <div className="content-box">
            <p>{sensitivityResult?.description}</p>
          </div>
        </SensitivityResulBox>
        <SensitivityResultSubBox>
          <p>집에서 들리는 소음을 측정해보세요</p>
          <div className="measure-box">{sensitivityResult?.contents}</div>
        </SensitivityResultSubBox>
        <NoiseResultBox>
          <p>내 귀는 어떤 소리에 더 예민할까?</p>
          <div className="noise-box">{`주파수대에 따른 상대적인 청감 민감도(등청감곡선) 검사 결과, 당신은 ${noiseResult?.contents}`}</div>
        </NoiseResultBox>
        <InspectShareBox />
      </InspectResultBox> */}
      <FtBtnBox>
        <button onClick={() => {}}>테스트 다시하기</button>
      </FtBtnBox>
    </InspectResultContainer>
  );
};

export default InspectResultDetail;
